import { render, staticRenderFns } from "./SidePanelNav.vue?vue&type=template&id=3503d5bd&scoped=true&"
import script from "./SidePanelNav.vue?vue&type=script&lang=js&"
export * from "./SidePanelNav.vue?vue&type=script&lang=js&"
import style0 from "./SidePanelNav.vue?vue&type=style&index=0&id=3503d5bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3503d5bd",
  null
  
)

export default component.exports